import Divider from 'components/divider';
import Hero from 'components/hero';
import Layout from 'components/layout';
import Panel from 'components/panel';
import PromoLogo from 'components/promo-logo';
import SEO from 'components/seo';
import menuData from 'content/navigation.yaml';
import { graphql, useStaticQuery } from 'gatsby';
import Image from 'gatsby-image';
import React from 'react';

const buyLink = menuData.find(item => item.id === 'buy-link').url;

const IndexPage = () => {
  const imageData = useStaticQuery(graphql`
    query dialImageAndImagesForGallery {
      allFile(
        filter: { relativePath: { glob: "lightbox/*.jpg" } }
        sort: { fields: [relativePath] }
      ) {
        edges {
          node {
            childImageSharp {
              thumb: fixed(width: 420, height: 276) {
                ...GatsbyImageSharpFixed
              }
              full: fluid(maxWidth: 1920) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      file(relativePath: { eq: "dial.png" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          # Makes it trivial to update as your page's design changes.
          fixed(width: 710, height: 710) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `);
  return (
    <Layout pageClass="home">
      <SEO />
      <Hero
        images={imageData.allFile.edges.slice(0, 2).map(x => x.node)}
        background="hero"
        mobileBackground="hero.mobile"
        logos={[
          {
            image: 'theory11',
            url: 'https://www.theory11.com',
            text: 'Presented by',
          },
          {
            image: 'target',
            url: buyLink,
            text: 'Available exclusively at',
            mobile: true,
          },
        ]}
      >
        an ever-evolving game of trivia, codes, puzzles, and discovery only from
        the mind of neil patrick harris
      </Hero>
      <Divider />
      <Panel
        anchor="about"
        title="For you alone"
        layout="right"
        images={imageData.allFile.edges.slice(0, 2).map(x => x.node)}
        background="panel-1"
        mobileBackground="panel-1.mobile"
        footer={
          <a className="button" href={buyLink}>
            Buy Game
          </a>
        }
      >
        A game uniquely designed to challenge only ONE person - and it seems
        that person is you! And only you. Alone. Can you handle it?
      </Panel>
      <Divider thick />
      <Panel
        title="The Ultimate Brain Challenge"
        layout="left"
        images={imageData.allFile.edges.slice(2, 4).map(x => x.node)}
        background="panel-2"
        mobileBackground="panel-2.mobile"
      >
        Or at least in the top 7. There are lots of great games out there.
        Anyways, prepare to set out on an exciting adventure like no other as
        you discover, unlock, and decode the secrets of BoxONE!
      </Panel>
      <Divider />
      <Panel
        title="a game for one - created by one"
        layout="bottom"
        background="panel-3"
        icon="key"
        style={{ paddingBottom: 140, paddingTop: 140 }}
        images={imageData.allFile.edges.slice(4, 6).map(x => x.node)}
      >
        From the brainwaves of Neil Patrick Harris comes an interactive
        challenge. Use your wits and decode each layer of BoxONE.
      </Panel>
      <Divider thick />
      <Panel
        title="Inside the box"
        layout="bottom"
        dial
        background="panel-4"
        tag
        style={{ paddingBottom: 0, paddingTop: 140 }}
        mobileStyle={{ paddingTop: 204 }}
        images={imageData.allFile.edges.slice(6, 8).map(x => x.node)}
        footer={
          <>
            <h3>Ages 14+</h3>
            <h4>Internet access required</h4>

            <div className="panel__dial">
              <Image fixed={imageData.file.childImageSharp.fixed} />
              <a className="button" href={buyLink}>
                Buy Game
              </a>
            </div>
          </>
        }
      >
        BoxONE represents years of thought and careful planning by Neil alone,
        designed for you alone. Everything you need to decode each challenge is
        inside the box.
      </Panel>
      <Divider thick />
      <Panel
        title="Are you ready?"
        layout="bottom"
        icon="lock"
        anchor="buy-game"
        style={{ paddingBottom: 0, marginBottom: -114, zIndex: 1 }}
        mobileStyle={{ marginBottom: -180 }}
      >
        <a className="button" href={buyLink}>
          Buy Game
        </a>
        <PromoLogo
          text="Available exclusively at"
          image="target"
          mobile
          url={buyLink}
        />
      </Panel>
    </Layout>
  );
};

export default IndexPage;
